/* eslint-disable */
import dicts from './example'

// 议案、建议、提案-表单
export const branchPoliticsProposalForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // title: [{ required: true, message: '请输入', trigger: 'blur' }],
            // writer: [{ required: true, message: '请输入', trigger: 'blur' }],
            // submitTime: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // submitChannel: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            category: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
            // rewardStatus: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // caseStatus: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // replyStatus: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
        },
    },
    items: [
        {
            label: '题目',
            prop: 'title',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            label: '执笔人',
            prop: 'writer',
            maxlength: 20,
            showWordLimit: true,
            clearable: true,
        },

        {
            type: 'datepicker',
            label: '报送时间',
            prop: 'submitTime',
            clearable: true,
            format: 'yyyy-MM',
            dateType: 'month',
        },
        {
            type: 'cascader',
            label: '报送渠道',
            prop: 'submitChannel',
            options: dicts.submitChannel(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'select',
            label: '关注领域',
            prop: 'category',
            options: dicts.category(),
        },
        {
            type: 'cascader',
            label: '获奖情况',
            prop: 'rewardStatus',
            options: dicts.rewardStatus(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'cascader',
            label: '立案情况',
            prop: 'caseStatus',
            options: dicts.rewardStatus(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'cascader',
            label: '批示答复情况',
            prop: 'replyStatus',
            options: dicts.rewardStatus(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'textarea',
            label: '备注',
            prop: 'remark',
            maxlength: 5000,
            showWordLimit: true,
            clearable: true,
            rows: 6
        }
    ]
}

// 议案、建议、提案-表格
export const branchPoliticsProposalCols = [
    {
        title: '题目',
        key: 'title',
        tooltip: true,
        minWidth: 200,
    },
    {
        title: '执笔人',
        key: 'writer',
        tooltip: true,
        width: 160,
    },
    {
        title: '报送时间',
        key: 'submitTime',
        width: 160,
        tooltip: true,
    },
    {
        title: '报送渠道',
        key: 'submitChannel',
        width: 240,
        tooltip: true,
    },
    {
        title: '关注领域',
        slot: 'category',
        width: 200,
        tooltip: true,
    },
    {
        title: '获奖情况',
        key: 'rewardStatus',
        width: 240,
        tooltip: true,
    },
    {
        title: '立案情况',
        key: 'caseStatus',
        width: 240,
        tooltip: true,
    },
    {
        title: '批示答复情况',
        key: 'replyStatus',
        width: 240,
        tooltip: true,
    },
    {
        title: '备注',
        key: 'remark',
        width: 300,
        tooltip: true
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]

// 社情民意信息 - 表单
export const branchPoliticsSocialForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // title: [{ required: true, message: '请输入', trigger: 'blur' }],
            // writer: [{ required: true, message: '请输入', trigger: 'blur' }],
            // submitTime: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // submitChannel: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            category: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
            // rewardStatus: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // usedStatus: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
        },
    },
    items: [
        {
            label: '题目',
            prop: 'title',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            label: '执笔人',
            prop: 'writer',
            maxlength: 20,
            showWordLimit: true,
            clearable: true,
        },

        {
            type: 'datepicker',
            label: '报送时间',
            prop: 'submitTime',
            clearable: true,
            format: 'yyyy-MM',
            dateType: 'month',
        },
        {
            type: 'cascader',
            label: '报送渠道',
            prop: 'submitChannel',
            options: dicts.submitChannel(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'select',
            label: '关注领域',
            prop: 'category',
            options: dicts.category(),
        },
        {
            type: 'cascader',
            label: '获奖情况',
            prop: 'rewardStatus',
            options: dicts.rewardStatus(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'cascader',
            label: '采用情况',
            prop: 'usedStatus',
            options: dicts.rewardStatus(),
            props: {
                multiple: true,
            },
        },
        {
            type: 'textarea',
            label: '备注',
            prop: 'remark',
            maxlength: 5000,
            showWordLimit: true,
            clearable: true,
            rows: 6
        }
    ],
}

// 社情民意信息 - 表格
export const branchPoliticsSocialCols = [
    {
        title: '题目',
        key: 'title',
        tooltip: true,
        minWidth: 200,
    },
    {
        title: '执笔人',
        key: 'writer',
        tooltip: true,
        width: 160,
        tooltip: true,
    },
    {
        title: '报送时间',
        key: 'submitTime',
        width: 160,
        tooltip: true,
    },
    {
        title: '报送渠道',
        key: 'submitChannel',
        width: 240,
        tooltip: true,
    },
    {
        title: '关注领域',
        slot: 'category',
        width: 160,
        tooltip: true,
    },
    {
        title: '获奖情况',
        key: 'rewardStatus',
        width: 240,
        tooltip: true,
    },
    {
        title: '采用情况',
        key: 'usedStatus',
        width: 240,
        tooltip: true,
    },
    {
        title: '备注',
        key: 'remark',
        width: 300,
        tooltip: true
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]